import { buildMakeUseAxios } from "@api";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { IRole } from "@bbj-types/role";
import { useCallback } from "react";

const settingsAxios = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}`);
export const useGetRoles = () => {
  const [state, execute, cancel] = settingsAxios<Omit<IRole, "permissions" | "isCandidateDefault">[], void, unknown>(
    {
      url: "/roles",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    ({ permissions, count, allOrganisations }) => {
      const queryParams = new URLSearchParams();
      if (permissions) queryParams.append("permissions", "true");
      if (count) queryParams.append("count", "true");
      if (allOrganisations) queryParams.append("allOrganisations", "true");
      return execute({
        url: `/roles?${queryParams.toString()}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useDeleteRoles = () => {
  const [state, execute, cancel] = settingsAxios(
    {
      url: "/roles",
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (roleToDelete, moveToRole) => {
      return execute({
        url: `/roles`,
        params: {
          roleToDelete,
          moveToRole,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const usePostRoles = () => {
  const [state, execute, cancel] = settingsAxios(
    {
      url: "/roles",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (roles) => {
      return execute({ data: roles });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const usePatchRoles = () => {
  const [state, execute, cancel] = settingsAxios(
    {
      url: "/roles",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (roles) => {
      return execute({ data: roles });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
